import { css } from '@linaria/core';

export const collections = css`
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
`;
